export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8312.c3dcfb02.jpg";